import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../../images/57logo.jpeg";
import Apiservice from "../Apiservice";

const Login = ({ onLogin }) => {
  const userNameRef = useRef("");
  const passwordRef = useRef("")

  const onSubmit = async (e) => {
    e.preventDefault();

    const userName = userNameRef.current?.value?.trim();
    const password = passwordRef.current?.value?.trim();

    if (!userName || !password) {
      alert("Username & Password required");
      return;
    }

    const data = { userName, password };

    if (onLogin) {
      await onLogin(data);
    }
  };

  return (
    // <div className="container-fluid vh-100 d-flex" style={{ overflow: 'hidden' }}>
    <div className="container-fluid vh-100 d-flex p-0 overflow-hidden">
      <div className="row w-100 g-0">
        <div className="col-md-6 p-0 d-none d-md-block">
          <img
            src={Logo}
            alt="Logo"
            className="img-fluid w-100 h-100"
            style={{ objectFit: "cover", filter: "brightness(80%)", display: "block" }}
          />
        </div>
        <div
          className="col-md-6 col-12 p-0 d-flex justify-content-center align-items-center"
          style={{ backgroundColor: "#f7f8fc" }}
        >
          <div className="text-center w-75 p-4 rounded shadow-lg"
            style={{ backgroundColor: "#ffffff", border: "1px solid #ddd" }}>
            <h3 className="mb-4 text-primary fw-bold">57 PEACE PROTECTION</h3>
            <h3 className="mb-4 text-primary fw-bold">Welcome Back!</h3>
            <p className="mb-4 text-muted">Login to access your account</p>
            <div className="mb-3 text-start">
              <label htmlFor="username" className="form-label text-muted">
                User Name
              </label>
              <input type="text" id="username"
                className="form-control form-control-sm" placeholder="Enter User Name" ref={userNameRef} />
            </div>
            <div className="mb-3 text-start">
              <label htmlFor="password" className="form-label text-muted">
                Password
              </label>
              <input type="password" id="password"
                className="form-control form-control-sm" placeholder="Enter Password" ref={passwordRef} />
            </div>
            <button className="btn btn-primary w-100 btn-sm" onClick={onSubmit}>
              Login
            </button>
          </div>
        </div>
      </div>
    </div>

  );
};

export default Login;
